<div class="event-popup">
    <div class="title">{{newEvent ? ('bikeshop.modal.add_edit_user.technician_form.event.add_event' | translate) : ('bikeshop.modal.add_edit_user.technician_form.event.edit_event' | translate)}}</div>
    <div>
        <div class="row margin-top-8">
            <div class="col-md-4 label">{{ 'general.description' | translate }}:</div>
            <div class="col-md-8">
                <input type="text" pInputText [(ngModel)]="event.Description"/>
            </div>
        </div>
        <div class="row margin-top-8">
            <div class="col-md-4 label">Event Date:</div>
            <div class="col-md-8">
                <p-calendar dateFormat="{{countryData.DatePickerFormat}}" placeholder="" [minDate]="minDate"
                            [(ngModel)]="event.StartTime"></p-calendar>
            </div>
        </div>
        <div class="row margin-top-8">
            <div class="col-md-4 label">{{ 'general.start' | translate }}:</div>
            <div class="col-md-8">
                <p-calendar dateFormat="HH:mm" [timeOnly]="true" [(ngModel)]="startTime"
                            (ngModelChange)="endTime=startTime"></p-calendar>
            </div>
        </div>
        <div class="row margin-top-8">
            <div class="col-md-4 label">{{ 'general.end' | translate }}:</div>
            <div class="col-md-8">
                <p-calendar dateFormat="HH:mm" [timeOnly]="true" [(ngModel)]="endTime"></p-calendar>
            </div>
        </div>
        <div class="row margin-top-8" *ngIf="!event.ID">
            <div class="col-md-4 label">{{ 'bikeshop.modal.add_edit_user.technician_form.event.recurring' | translate }}
                :
            </div>
            <div class="col-md-8">
                <p-inputSwitch [(ngModel)]="event.IsRecurringEvent"></p-inputSwitch>
            </div>
        </div>
        <div class="row margin-top-8" *ngIf="event.IsRecurringEvent">
            <div class="col-md-4 label">{{'bikeshop.modal.add_edit_user.technician_form.event.occurs_every_day' | translate}}
                :
            </div>
            <div class="col-md-8">
                <input type="number" pInputText [(ngModel)]="event.RecurIntervalDays"/>
            </div>
        </div>
        <div class="row margin-top-8" *ngIf="event.IsRecurringEvent">
            <div class="col-md-4 label">{{'bikeshop.modal.add_edit_user.technician_form.event.repeats_times' | translate}}
                :
            </div>
            <div class="col-md-8">
                <input type="number" pInputText [(ngModel)]="event.RecurringCount"/>
            </div>
        </div>
        <div class="row margin-top-8">
            <div class="col-md-6"></div>
            <div class="col-md-6">
                <button pButton type="button" class="p-button-raised full-width"
                        label="{{'bikeshop.modal.add_edit_user.technician_form.event.button.save_event' | translate}}"
                        (click)="saveEvent()" [disabled]="busy || !valid()"></button>
            </div>
        </div>
    </div>
</div>
